import uniqBy from 'lodash/uniqBy';

import { isDefined } from '@utils/isDefined';

import type { FiledValueParams } from '../FieldHistoryList';

export function uniqHistoryByValue<T>(values: FiledValueParams<T>[], authorId?: string): FiledValueParams<T>[] {
    const ownValues = isDefined(authorId) ? values.filter(value => value.authorId === authorId) : values;

    return uniqBy(ownValues, 'value');
}
